'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamor = require('glamor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getStyle = function getStyle(_ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      danger = _ref.danger;

  var intent = void 0;

  if (danger) intent = _theme2.default.intent.danger;else if (secondary) intent = _theme2.default.intent.secondary;else if (primary) intent = _theme2.default.intent.primary;

  if (!intent) return '';

  return (0, _glamor.css)({
    color: intent.default.linkColor,
    '&:hover': {
      color: intent.hover.linkColor
    },
    '&:focus': {
      color: intent.focus.linkColor
    },
    '&:active, &.active': {
      color: intent.active.linkColor
    }
  });
};

var baseStyles = (0, _glamor.css)({
  transition: 50,
  transitionProperty: 'background-color, color, box-shadow, opacity',
  textDecoration: 'none',
  '&.underline': {
    textDecoration: 'underline'
  },
  '&:active, &:focus': {
    outline: 'none'
  }
});

var parseProps = function parseProps(_ref2) {
  var underline = _ref2.underline,
      active = _ref2.active,
      primary = _ref2.primary,
      secondary = _ref2.secondary,
      danger = _ref2.danger,
      naked = _ref2.naked,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, ['underline', 'active', 'primary', 'secondary', 'danger', 'naked', 'className']);

  return _extends({
    className: (0, _classnames2.default)('' + baseStyles, '' + getStyle({ primary: primary, secondary: secondary, naked: naked, danger: danger }), underline && 'underline', active && 'active', className),
    is: active ? 'span' : 'a'
  }, props);
};

var Link = function Link(props) {
  return _react2.default.createElement(_Text2.default, parseProps(props));
};

Link.propTypes = _extends({}, _Text2.default.propTypes, {
  underline: _propTypes2.default.bool,
  primary: _propTypes2.default.bool,
  secondary: _propTypes2.default.bool,
  danger: _propTypes2.default.bool,
  active: _propTypes2.default.bool
});

Link.defaultProps = {
  // underline: true,
  primary: true
};

Link.displayName = 'Link';

exports.default = Link;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0xpbmsuanMiXSwibmFtZXMiOlsiZ2V0U3R5bGUiLCJwcmltYXJ5Iiwic2Vjb25kYXJ5IiwiZGFuZ2VyIiwiaW50ZW50IiwiY29sb3IiLCJkZWZhdWx0IiwibGlua0NvbG9yIiwiaG92ZXIiLCJmb2N1cyIsImFjdGl2ZSIsImJhc2VTdHlsZXMiLCJ0cmFuc2l0aW9uIiwidHJhbnNpdGlvblByb3BlcnR5IiwidGV4dERlY29yYXRpb24iLCJvdXRsaW5lIiwicGFyc2VQcm9wcyIsInVuZGVybGluZSIsIm5ha2VkIiwiY2xhc3NOYW1lIiwicHJvcHMiLCJpcyIsIkxpbmsiLCJjcmVhdGVFbGVtZW50IiwicHJvcFR5cGVzIiwiYm9vbCIsImRlZmF1bHRQcm9wcyIsImRpc3BsYXlOYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUFBOzs7O0FBQ0E7Ozs7QUFDQTs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7Ozs7O0FBRUEsSUFBTUEsV0FBVyxTQUFYQSxRQUFXLE9BQW9DO0FBQUEsTUFBakNDLE9BQWlDLFFBQWpDQSxPQUFpQztBQUFBLE1BQXhCQyxTQUF3QixRQUF4QkEsU0FBd0I7QUFBQSxNQUFiQyxNQUFhLFFBQWJBLE1BQWE7O0FBQ25ELE1BQUlDLGVBQUo7O0FBRUEsTUFBSUQsTUFBSixFQUFZQyxTQUFTLGdCQUFNQSxNQUFOLENBQWFELE1BQXRCLENBQVosS0FDSyxJQUFJRCxTQUFKLEVBQWVFLFNBQVMsZ0JBQU1BLE1BQU4sQ0FBYUYsU0FBdEIsQ0FBZixLQUNBLElBQUlELE9BQUosRUFBYUcsU0FBUyxnQkFBTUEsTUFBTixDQUFhSCxPQUF0Qjs7QUFFbEIsTUFBSSxDQUFDRyxNQUFMLEVBQWEsT0FBTyxFQUFQOztBQUViLFNBQU8saUJBQUk7QUFDVEMsV0FBT0QsT0FBT0UsT0FBUCxDQUFlQyxTQURiO0FBRVQsZUFBVztBQUNURixhQUFPRCxPQUFPSSxLQUFQLENBQWFEO0FBRFgsS0FGRjtBQUtULGVBQVc7QUFDVEYsYUFBT0QsT0FBT0ssS0FBUCxDQUFhRjtBQURYLEtBTEY7QUFRVCwwQkFBc0I7QUFDcEJGLGFBQU9ELE9BQU9NLE1BQVAsQ0FBY0g7QUFERDtBQVJiLEdBQUosQ0FBUDtBQVlELENBckJEOztBQXVCQSxJQUFNSSxhQUFhLGlCQUFJO0FBQ3JCQyxjQUFZLEVBRFM7QUFFckJDLHNCQUFvQiw4Q0FGQztBQUdyQkMsa0JBQWdCLE1BSEs7QUFJckIsaUJBQWU7QUFDYkEsb0JBQWdCO0FBREgsR0FKTTtBQU9yQix1QkFBcUI7QUFDbkJDLGFBQVM7QUFEVTtBQVBBLENBQUosQ0FBbkI7O0FBWUEsSUFBTUMsYUFBYSxTQUFiQSxVQUFhO0FBQUEsTUFDakJDLFNBRGlCLFNBQ2pCQSxTQURpQjtBQUFBLE1BRWpCUCxNQUZpQixTQUVqQkEsTUFGaUI7QUFBQSxNQUdqQlQsT0FIaUIsU0FHakJBLE9BSGlCO0FBQUEsTUFJakJDLFNBSmlCLFNBSWpCQSxTQUppQjtBQUFBLE1BS2pCQyxNQUxpQixTQUtqQkEsTUFMaUI7QUFBQSxNQU1qQmUsS0FOaUIsU0FNakJBLEtBTmlCO0FBQUEsTUFPakJDLFNBUGlCLFNBT2pCQSxTQVBpQjtBQUFBLE1BUWRDLEtBUmM7O0FBQUE7QUFVakJELGVBQVcsK0JBQU1SLFVBQU4sT0FDTlgsU0FBUyxFQUFFQyxnQkFBRixFQUFXQyxvQkFBWCxFQUFzQmdCLFlBQXRCLEVBQTZCZixjQUE3QixFQUFULENBRE0sRUFFVGMsYUFBYSxXQUZKLEVBR1RQLFVBQVUsUUFIRCxFQUlUUyxTQUpTLENBVk07QUFlakJFLFFBQUlYLFNBQVMsTUFBVCxHQUFrQjtBQWZMLEtBZ0JkVSxLQWhCYztBQUFBLENBQW5COztBQW1CQSxJQUFNRSxPQUFPLFNBQVBBLElBQU87QUFBQSxTQUFTLGdCQUFNQyxhQUFOLGlCQUEwQlAsV0FBV0ksS0FBWCxDQUExQixDQUFUO0FBQUEsQ0FBYjs7QUFFQUUsS0FBS0UsU0FBTCxnQkFDSyxlQUFLQSxTQURWO0FBRUVQLGFBQVcsb0JBQVVRLElBRnZCO0FBR0V4QixXQUFTLG9CQUFVd0IsSUFIckI7QUFJRXZCLGFBQVcsb0JBQVV1QixJQUp2QjtBQUtFdEIsVUFBUSxvQkFBVXNCLElBTHBCO0FBTUVmLFVBQVEsb0JBQVVlO0FBTnBCOztBQVNBSCxLQUFLSSxZQUFMLEdBQW9CO0FBQ2xCO0FBQ0F6QixXQUFTO0FBRlMsQ0FBcEI7O0FBS0FxQixLQUFLSyxXQUFMLEdBQW1CLE1BQW5COztrQkFFZUwsSSIsImZpbGUiOiJMaW5rLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJ1xuaW1wb3J0IHsgY3NzIH0gZnJvbSAnZ2xhbW9yJ1xuaW1wb3J0IGN4IGZyb20gJ2NsYXNzbmFtZXMnXG5pbXBvcnQgVGV4dCBmcm9tICcuL1RleHQnXG5pbXBvcnQgdGhlbWUgZnJvbSAnLi90aGVtZSdcblxuY29uc3QgZ2V0U3R5bGUgPSAoeyBwcmltYXJ5LCBzZWNvbmRhcnksIGRhbmdlciB9KSA9PiB7XG4gIGxldCBpbnRlbnRcblxuICBpZiAoZGFuZ2VyKSBpbnRlbnQgPSB0aGVtZS5pbnRlbnQuZGFuZ2VyXG4gIGVsc2UgaWYgKHNlY29uZGFyeSkgaW50ZW50ID0gdGhlbWUuaW50ZW50LnNlY29uZGFyeVxuICBlbHNlIGlmIChwcmltYXJ5KSBpbnRlbnQgPSB0aGVtZS5pbnRlbnQucHJpbWFyeVxuXG4gIGlmICghaW50ZW50KSByZXR1cm4gJydcblxuICByZXR1cm4gY3NzKHtcbiAgICBjb2xvcjogaW50ZW50LmRlZmF1bHQubGlua0NvbG9yLFxuICAgICcmOmhvdmVyJzoge1xuICAgICAgY29sb3I6IGludGVudC5ob3Zlci5saW5rQ29sb3JcbiAgICB9LFxuICAgICcmOmZvY3VzJzoge1xuICAgICAgY29sb3I6IGludGVudC5mb2N1cy5saW5rQ29sb3JcbiAgICB9LFxuICAgICcmOmFjdGl2ZSwgJi5hY3RpdmUnOiB7XG4gICAgICBjb2xvcjogaW50ZW50LmFjdGl2ZS5saW5rQ29sb3JcbiAgICB9XG4gIH0pXG59XG5cbmNvbnN0IGJhc2VTdHlsZXMgPSBjc3Moe1xuICB0cmFuc2l0aW9uOiA1MCxcbiAgdHJhbnNpdGlvblByb3BlcnR5OiAnYmFja2dyb3VuZC1jb2xvciwgY29sb3IsIGJveC1zaGFkb3csIG9wYWNpdHknLFxuICB0ZXh0RGVjb3JhdGlvbjogJ25vbmUnLFxuICAnJi51bmRlcmxpbmUnOiB7XG4gICAgdGV4dERlY29yYXRpb246ICd1bmRlcmxpbmUnXG4gIH0sXG4gICcmOmFjdGl2ZSwgJjpmb2N1cyc6IHtcbiAgICBvdXRsaW5lOiAnbm9uZSdcbiAgfVxufSlcblxuY29uc3QgcGFyc2VQcm9wcyA9ICh7XG4gIHVuZGVybGluZSxcbiAgYWN0aXZlLFxuICBwcmltYXJ5LFxuICBzZWNvbmRhcnksXG4gIGRhbmdlcixcbiAgbmFrZWQsXG4gIGNsYXNzTmFtZSxcbiAgLi4ucHJvcHNcbn0pID0+ICh7XG4gIGNsYXNzTmFtZTogY3goYCR7YmFzZVN0eWxlc31gLFxuICAgIGAke2dldFN0eWxlKHsgcHJpbWFyeSwgc2Vjb25kYXJ5LCBuYWtlZCwgZGFuZ2VyIH0pfWAsXG4gICAgdW5kZXJsaW5lICYmICd1bmRlcmxpbmUnLFxuICAgIGFjdGl2ZSAmJiAnYWN0aXZlJyxcbiAgICBjbGFzc05hbWUpLFxuICBpczogYWN0aXZlID8gJ3NwYW4nIDogJ2EnLFxuICAuLi5wcm9wc1xufSlcblxuY29uc3QgTGluayA9IHByb3BzID0+IFJlYWN0LmNyZWF0ZUVsZW1lbnQoVGV4dCwgcGFyc2VQcm9wcyhwcm9wcykpXG5cbkxpbmsucHJvcFR5cGVzID0ge1xuICAuLi5UZXh0LnByb3BUeXBlcyxcbiAgdW5kZXJsaW5lOiBQcm9wVHlwZXMuYm9vbCxcbiAgcHJpbWFyeTogUHJvcFR5cGVzLmJvb2wsXG4gIHNlY29uZGFyeTogUHJvcFR5cGVzLmJvb2wsXG4gIGRhbmdlcjogUHJvcFR5cGVzLmJvb2wsXG4gIGFjdGl2ZTogUHJvcFR5cGVzLmJvb2xcbn1cblxuTGluay5kZWZhdWx0UHJvcHMgPSB7XG4gIC8vIHVuZGVybGluZTogdHJ1ZSxcbiAgcHJpbWFyeTogdHJ1ZVxufVxuXG5MaW5rLmRpc3BsYXlOYW1lID0gJ0xpbmsnXG5cbmV4cG9ydCBkZWZhdWx0IExpbmtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/Link.js
// module id = 291
// module chunks = 0